import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaGlobe, FaMapMarkerAlt, FaUsers, FaCalendarAlt, FaFacebook, FaInstagram, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './Asociaciones.css';

// Importar imágenes de asociaciones
import estamenaImage1 from '../../Images/estamena/estamena1.webp';
import estamenaImage2 from '../../Images/estamena/estamena2.webp';
import bandaImage1 from '../../Images/cruz-acuestas/cruz-acuestas.webp';
import bandaImage2 from '../../Images/cruz-acuestas/cruz-acuestas1.webp';

const Asociaciones = () => {
  const [expandedAsociacion, setExpandedAsociacion] = useState(null);

  const toggleAsociacion = (id) => {
    setExpandedAsociacion(expandedAsociacion === id ? null : id);
  };

  const asociaciones = [
    {
      id: 1,
      nombre: "ACDR LA ESTAMEÑA",
      tipo: "Asociación Cultural, Deportiva y Recreativa",
      descripcion: "Asociación constituida en 1987-1988 para fomentar la cultura, el deporte y el ocio en Escalonilla. Con más de 35 años de historia, es una de las asociaciones más antiguas y activas del municipio.",
      actividades: [
        "Baile de Fin de Año",
        "Cabalgata de Reyes Magos", 
        "Semana Cultural (seña de identidad)",
        "Excursiones culturales",
        "Actividades deportivas",
        "Proyecciones de películas",
        "Conciertos y actuaciones"
      ],
      objetivos: [
        "Fomentar la cultura local",
        "Promover el deporte y la recreación",
        "Organizar actividades de ocio",
        "Preservar las tradiciones del pueblo",
        "Favorecer la participación ciudadana"
      ],
      juntaDirectiva: {
        presidente: "Antonio Gutiérrez Santurde",
        secretaria: "Esperanza Martín-Cleto García",
        tesorera: "Rosa Mª Herce Sánchez",
        vocales: [
          "Higinio Gómez Ayllón",
          "Mª Reyes López López",
          "Beatriz Pinel Calvo",
          "Paula González Herce",
          "Laura Horcajuelo Gómez",
          "Alberto Gómez Martín-Cleto",
          "Javier Benítez Pinel",
          "Miriam Benítez Vallejo",
          "Virginia Cruz del Valle"
        ]
      },
      historia: "La ACDR La Estameña cuenta con su propio escudo que destaca una madeja de estambre de color rojo, recordando a los antiguos telares que dieron fama a Escalonilla. Su nombre proviene de las estameñas, tejidos tradicionales del pueblo.",
      financiacion: "Se financia con la cuota anual de los socios (330 socios actuales), ayudas de empresas locales, subvenciones del Ayuntamiento de Escalonilla y de la Diputación de Toledo.",
      imagenes: [estamenaImage1, estamenaImage2],
      email: "acdrlaestamena@hotmail.com",
      facebook: "https://www.facebook.com/asociacionculturaldeescalonilla",
      instagram: "https://www.instagram.com/ac.laestamena?igsh=bzU3ZXBienMxNDJ0",
      whatsapp: "666953685",
      socios: "330 socios"
    },
    {
      id: 2,
      nombre: "A.M.C. STMO CRISTO DE LA CRUZ A CUESTAS",
      tipo: "Asociación Musical Cultural",
      descripcion: "Banda de música fundada en 1893 por un grupo de artesanos. Con más de 130 años de historia, ha atravesado épocas de esplendor y decadencia, pero nunca ha desaparecido. Actualmente cuenta con 30 músicos y una escuela de música.",
      actividades: [
        "Conciertos y actuaciones musicales",
        "Participación en certámenes regionales", 
        "Actuaciones en municipios de Toledo",
        "Escuela de música para niños y adultos",
        "Grabación de CD 'Escalonilla en fiestas'",
        "Actuaciones en eventos locales",
        "Colaboración con el AMPA del colegio"
      ],
      objetivos: [
        "Fomentar la música en Escalonilla",
        "Formar nuevos músicos", 
        "Preservar la tradición musical",
        "Participar en eventos culturales",
        "Promover la educación musical"
      ],
      historia: "Fundada en 1893 por artesanos locales, la banda alcanzó su pleno apogeo a principios del siglo XX, llegando a existir incluso dos bandas simultáneas. Destacó especialmente en 1915 en Torrijos. Bajo la dirección de Pedro Calvo Pascual (años 80-2003) participó en certámenes de la Junta de Comunidades y actuó por toda la geografía toledana.",
      financiacion: "Se financia con cuotas de socios, colaboraciones del AMPA del colegio Sagrados Corazones, ayudas municipales y actuaciones remuneradas.",
      juntaDirectiva: {
        director: "Juan José Badía (desde 2004)"
      },
      escuelaMusica: "Desde 2016 funciona la escuela de música en colaboración con el AMPA del colegio Sagrados Corazones, donde niños y adultos aprenden música para formar parte de la banda en el futuro.",
      imagenes: [bandaImage1, bandaImage2],
      email: "",
      facebook: "",
      instagram: "",
      whatsapp: "",
      socios: "30 músicos"
    }
  ];

  return (
    <div className="asociaciones-container">
      <div className="container">
        <h1>Asociaciones de Escalonilla</h1>

        {asociaciones.map((asociacion, index) => (
          <div key={asociacion.id} className="asociacion-card">
            <div className="asociacion-card-body">
              <div className="asociacion-header" onClick={() => toggleAsociacion(asociacion.id)}>
                <div className="asociacion-titulo">
                  <img 
                    src={asociacion.imagenes[0]} 
                    alt={`${asociacion.nombre} - Logo`}
                    className="asociacion-logo"
                  />
                  <div className="asociacion-titulo-texto">
                    <h3 className="asociacion-nombre">{asociacion.nombre}</h3>
                    <span className="asociacion-tipo">{asociacion.tipo}</span>
                  </div>
                </div>
                <div className="asociacion-expand">
                  {expandedAsociacion === asociacion.id ? 
                    <FaChevronUp className="expand-icon" /> : 
                    <FaChevronDown className="expand-icon" />
                  }
                </div>
              </div>

              {expandedAsociacion === asociacion.id && (
                <div className="asociacion-content">
                  <div className="asociacion-imagen-integrantes">
                    <img 
                      src={asociacion.imagenes[1]} 
                      alt={`${asociacion.nombre} - Integrantes`}
                      className="asociacion-image-integrantes"
                    />
                  </div>

                  <div className="asociacion-info">
                    <div className="asociacion-descripcion">
                      <p>{asociacion.descripcion}</p>
                    </div>

                    <div className="asociacion-objetivos">
                      <h3>Objetivos</h3>
                      <ul>
                        {asociacion.objetivos.map((objetivo, objIndex) => (
                          <li key={objIndex}>{objetivo}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="asociacion-actividades">
                      <h3>Actividades Principales</h3>
                      <ul>
                        {asociacion.actividades.map((actividad, actIndex) => (
                          <li key={actIndex}>{actividad}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="asociacion-historia">
                      <h3>Historia</h3>
                      <p>{asociacion.historia}</p>
                    </div>

                    <div className="asociacion-financiacion">
                      <h3>Financiación</h3>
                      <p>{asociacion.financiacion}</p>
                    </div>

                    {asociacion.escuelaMusica && (
                      <div className="asociacion-escuela">
                        <h3>Escuela de Música</h3>
                        <p>{asociacion.escuelaMusica}</p>
                      </div>
                    )}

                    <div className="asociacion-junta">
                      <h3>Junta Directiva</h3>
                      <div className="junta-info">
                        {asociacion.juntaDirectiva.director && (
                          <p><strong>Director:</strong> {asociacion.juntaDirectiva.director}</p>
                        )}
                        {asociacion.juntaDirectiva.presidente && (
                          <p><strong>Presidente:</strong> {asociacion.juntaDirectiva.presidente}</p>
                        )}
                        {asociacion.juntaDirectiva.secretaria && (
                          <p><strong>Secretaria:</strong> {asociacion.juntaDirectiva.secretaria}</p>
                        )}
                        {asociacion.juntaDirectiva.tesorera && (
                          <p><strong>Tesorera:</strong> {asociacion.juntaDirectiva.tesorera}</p>
                        )}
                        {asociacion.juntaDirectiva.vocales && (
                          <div className="vocales">
                            <strong>Vocales:</strong>
                            <ul>
                              {asociacion.juntaDirectiva.vocales.map((vocal, vocalIndex) => (
                                <li key={vocalIndex}>{vocal}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="asociacion-contacto">
                      <h3>Contacto</h3>
                      <div className="contacto-grid">
                        {asociacion.email && (
                          <div className="contacto-item">
                            <FaEnvelope className="contacto-icon" />
                            <a href={`mailto:${asociacion.email}`}>{asociacion.email}</a>
                          </div>
                        )}
                      
                        {asociacion.whatsapp && (
                          <div className="contacto-item">
                            <FaPhone className="contacto-icon" />
                            <a href={`https://wa.me/${asociacion.whatsapp.replace(/\s/g, '')}`} target="_blank" rel="noopener noreferrer">
                              {asociacion.whatsapp}
                            </a>
                          </div>
                        )}
                        
                        {asociacion.facebook && (
                          <div className="contacto-item">
                            <FaFacebook className="contacto-icon" />
                            <a href={asociacion.facebook} target="_blank" rel="noopener noreferrer">
                              Facebook
                            </a>
                          </div>
                        )}
                        
                        {asociacion.instagram && (
                          <div className="contacto-item">
                            <FaInstagram className="contacto-icon" />
                            <a href={asociacion.instagram} target="_blank" rel="noopener noreferrer">
                              Instagram
                            </a>
                          </div>
                        )}

                        {asociacion.socios && (
                          <div className="contacto-item">
                            <FaUsers className="contacto-icon" />
                            <span>{asociacion.socios}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}

        <div className="contact-info">
          <h3>Apoyo a las Asociaciones</h3>
          <p>
            Desde el Ayuntamiento de Escalonilla apoyamos el desarrollo 
            asociativo local. Si necesitas información sobre estas asociaciones 
            o estás interesado en crear una nueva asociación en nuestro municipio, 
            no dudes en contactarnos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Asociaciones;
